import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SchoolAttendanceViewModel } from 'src/app/models/school.model';
import { StudentItemViewModel } from 'src/app/models/student.model';
import { SelectStudentEventPayload } from '../../models/event-payloads.model';
import { NewStudentItemComponent } from '../new-student-item/new-student-item.component';

@Component({
  selector: 'app-student-item-list',
  templateUrl: './student-item-list.component.html',
  styleUrls: ['./student-item-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NewStudentItemComponent]
})
export class StudentItemListComponent {
  @Input() school: SchoolAttendanceViewModel;
  @Output() selectStudent = new EventEmitter<SelectStudentEventPayload>();

  trackByFn(index: number, item: StudentItemViewModel): number {
    return item.id;
  }
}
